import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { array } from 'prop-types';


export class EntityInCharge extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeusers: [],
            activecontactlist: [],
        }
    };

    returnArrayElement = (array, element) => {

        console.log("returnArrayElement array length " + array.length + " " + element);

        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId == element) {
                console.log(array[i]);
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    returnArrayElementUseValue = (array, element) => {

        console.log("returnArrayElementUseValue array length " + array.length + " " + element);

        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeName == element) {
                console.log(array[i]);
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    loadActiveUsers = () => {
        fetch(global.variables.API_USEROPERATIONS_LOADACTIVEUSERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                var usersarray = [];

                for (var i = 0; i < result.listofusers.length; i++) {
                    var userjson = {
                        TypeId: result.listofusers[i].idLoginCredentials,
                        TypeName: result.listofusers[i].LoginName + " " + result.listofusers[i].LoginSurname
                    };

                    usersarray.push(userjson);
                }

                this.setState({
                    activeusers: usersarray
                });
            });
    };

    loadActiveContactList = () => {
        fetch(global.variables.API_USEROPERATIONS_LOADACTIVECONTACTLIST, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                var contactlistarray = [];

                for (var i = 0; i < result.listofusers.length; i++) {
                    var userjson = {
                        TypeId: result.listofusers[i].idContactListUsers,
                        TypeName: result.listofusers[i].LoginName + " " + result.listofusers[i].LoginSurname
                    };

                    contactlistarray.push(userjson);
                }

                this.setState({
                    activecontactlist: contactlistarray
                });
            });
    };

    async componentDidMount() {
        await this.loadActiveUsers();
        await this.loadActiveContactList();

        await this.forceUpdate();
    }

    render() {
        const {
            onChange,
            onSelectChange,
            onSelectChangeUseValue,
            cfcuContractManager,
            deuaSectorExpert,
            deuaMonitoringExpert,
            eudSectorManager,
            beneficiaryInstitution,
            beneficiaryUnitDepartment,
            contractingPartner,
            contactAtBeneficiaryInstitution,
            teamLeaderPartner,
            beneficiaryInstitutionOptions,

            //sector,

            userType,
        } = this.props;

        const {
            activeusers,
            activecontactlist,
        } = this.state;

        //var sectorOptions = [
        //    { TypeId: 1, TypeName: "Agriculture" },
        //    { TypeId: 2, TypeName: "Civil Society" },
        //    { TypeId: 3, TypeName: "Democracy and Governance" },
        //    { TypeId: 4, TypeName: "Education, Employement and Social Policies" },
        //    { TypeId: 5, TypeName: "Energy" },
        //    { TypeId: 6, TypeName: "Environment and Climate Action" },
        //    { TypeId: 7, TypeName: "Fundamental Rights" },
        //    { TypeId: 8, TypeName: "Home Affairs" },
        //    { TypeId: 9, TypeName: "Judiciary" },
        //    { TypeId: 10, TypeName: "Rule of Law and Fundamental Rights" },
        //    { TypeId: 11, TypeName: "Transport" },
        //];

        //var beneficiaryInstitutionOptions = [
        //    { TypeId: 1, TypeName: "Ministry of Justice" },
        //    { TypeId: 2, TypeName: "Ministry of Family, Labor and Social Services" },
        //    { TypeId: 3, TypeName: "Ministry of Environment and Urbanization" },
        //    { TypeId: 4, TypeName: "Ministry of Foreign Affairs" },
        //    { TypeId: 5, TypeName: "Ministry of Energy and Natural Resources" },
        //    { TypeId: 6, TypeName: "Ministry of Youth and Sports" },
        //    { TypeId: 7, TypeName: "Ministry of Treasury and Finance" },
        //    { TypeId: 8, TypeName: "Ministry of Interior" },
        //    { TypeId: 9, TypeName: "Ministry of Culture and Tourism" },
        //    { TypeId: 10, TypeName: "Ministry of National Education" },
        //    { TypeId: 11, TypeName: "Ministry of National Defense" },
        //    { TypeId: 12, TypeName: "Ministry of Health" },
        //    { TypeId: 13, TypeName: "Ministry of Industry and Technology" },
        //    { TypeId: 14, TypeName: "Ministry of Agriculture and Forestry" },
        //    { TypeId: 15, TypeName: "Ministry of Trade" },
        //    { TypeId: 16, TypeName: "Ministry of Transport and Infrastructure" },
        //];

        return (

            <Card>
                <CardHeader title="Entity In Charge" className='romis-card-header' />
                <CardContent>
                    {
                        //<TextField
                        //    label="CFCU Contract Manager :"
                        //    placeholder="CFCU Contract Manager"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true,
                        //    }}
                        //    onChange={onChange}
                        //    value={cfcuContractManager}
                        //    name="cfcuContractManager"

                        ///>
                    }

                    <Autocomplete
                        options={activecontactlist}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChangeUseValue(e, v, "cfcuContractManager")}
                        value={this.returnArrayElementUseValue(activecontactlist, cfcuContractManager)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Contracting Authority Contract Manager :"
                                placeholder="Contracting Authority Contract Manager"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />
                    {
                        //<TextField
                        //    label="DEUA Sector Expert :"
                        //    placeholder="DEUA Sector Expert"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true,
                        //    }}
                        //    onChange={onChange}
                        //    value={deuaSectorExpert}
                        //    name="deuaSectorExpert"

                        ///>
                    }

                    <Autocomplete
                        options={activecontactlist}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChangeUseValue(e, v, "deuaSectorExpert")}
                        value={this.returnArrayElementUseValue(activecontactlist, deuaSectorExpert)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="DEUA Sector Expert :"
                                placeholder="DEUA Sector Expert"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />

                    {
                        //<TextField
                        //    label="DEUA Monitoring Expert :"
                        //    placeholder="DEUA Monitoring Expert"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true,
                        //    }}
                        //    onChange={onChange}
                        //    value={deuaMonitoringExpert}
                        //    name="deuaMonitoringExpert"
                        ///>
                    }

                    <Autocomplete
                        options={activecontactlist}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChangeUseValue(e, v, "deuaMonitoringExpert")}
                        value={this.returnArrayElementUseValue(activecontactlist, deuaMonitoringExpert)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="DEUA Monitoring Expert :"
                                placeholder="DEUA Monitoring Expert"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />
                    {
                        //<TextField
                        //    label="EUD Sector Manager :"
                        //    placeholder="EUD Sector Manager"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true,
                        //    }}
                        //    onChange={onChange}
                        //    value={eudSectorManager}
                        //    name="eudSectorManager"
                        ///>
                    }

                    <Autocomplete
                        options={activecontactlist}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChangeUseValue(e, v, "eudSectorManager")}
                        value={this.returnArrayElementUseValue(activecontactlist, eudSectorManager)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="EUD Sector Manager :"
                                placeholder="EUD Sector Manager"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />

                    <Autocomplete
                        options={beneficiaryInstitutionOptions}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChangeUseValue(e, v, "beneficiaryInstitution")}
                        value={this.returnArrayElementUseValue(beneficiaryInstitutionOptions, beneficiaryInstitution)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Beneficiary Institution :"
                                placeholder="Beneficiary Institution"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />
                    {
                        //<TextField
                        //    label="Beneficiary Institution :"
                        //    placeholder="Beneficiary Institution"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true,
                        //    }}
                        //    onChange={onChange}
                        //    value={beneficiaryInstitution}
                        //    name="beneficiaryInstitution"
                        ///>
                    }
                    <TextField
                        label="Beneficiary Unit / Department :"
                        placeholder="Beneficiary Unit / Department"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={onChange}
                        value={beneficiaryUnitDepartment}
                        name="beneficiaryUnitDepartment"
                        disabled={userType !== 2 ? true : false}
                    />
                    <TextField
                        label="Project Coordinator at Beneficiary Institution :"
                        placeholder="Project Coordinator at Beneficiary Institution"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={onChange}
                        value={contactAtBeneficiaryInstitution}
                        name="contactAtBeneficiaryInstitution"
                        disabled={userType !== 2 ? true : false}
                    />
                    <TextField
                        label="Contractor / Twinning Partner :"
                        placeholder="Contractor / Twinning Partner"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={onChange}
                        value={contractingPartner}
                        name="contractingPartner"
                        disabled={userType !== 2 ? true : false}
                    />
                    <TextField
                        label="Team Leader / RTA at Partner :"
                        placeholder="Team Leader / RTA at Partner"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={onChange}
                        value={teamLeaderPartner}
                        name="teamLeaderPartner"
                        disabled={userType !== 2 ? true : false}
                    />
                </CardContent>

            </Card>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/EntityInCharge.js